"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _streamChatReact = require("stream-chat-react");
var _constants = require("../constants");
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ReactionsList = function ReactionsList(props) {
  var _useCustomMessageReac = (0, _utils.useCustomMessageReactionsSet)(),
    options = _useCustomMessageReac.options;
  return /*#__PURE__*/_react.default.createElement(_streamChatReact.SimpleReactionsList, _extends({}, props, {
    additionalEmojiProps: _constants.CHAT_REACTIONS_LIST_SIZE_SETTING,
    reactionOptions: options
  }));
};
var _default = ReactionsList;
exports.default = _default;